import createImmutableSelector from 'lib/immutable/selector'
import { ICategories } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getCategories = (state: any): ICategories => state.get('categoriesReducer')

export const categoriesSelector = createImmutableSelector(getCategories, (categories) => categories)
